<template>
  <div class="mt-4">
    <b-container fluid>
      <b-row v-if="!Entry">
          <b-col>
              <b-alert show variant="danger"> Category not found. </b-alert>
          </b-col>
      </b-row>
      <template v-else>
        <h3>{{Entry.Name}}</h3>
        <b-row>
          <b-col lg="3" class="hide-by-width">
            <category-tree :current-category="category"></category-tree>
          </b-col>
          <b-col>
            <CategoryTiles :parent-category="category" />
          </b-col>
        </b-row>    
      </template>
    </b-container>
  </div>
</template>

<script>

import ConfigService from "@/services/ConfigService";
import _ from 'lodash';
import CategoryTree from "./Nav/CategoryTree";
import CategoryTiles from "./Nav/CategoryTiles";

export default {
  name: "Category",
  props: ["category"],
  data() {
    return {
      catalog: null,
    };
  },
  computed: {
    Entry() {
      if(this.catalog) {
        return _.find(this.catalog, i => _.toUpper(i.Name) == _.toUpper(this.category)); // this.catalog[this.category];
      }
      else {
        return null;
      }
    },
    userInfo() {
      return this.$store.state.auth.userInfo;
    }
  },
  created() {
    ConfigService.GetCatalog().then(c => this.catalog = c);
  },
  methods: {
    Nav(root, child) {
      this.$router.push({ name: "CategorySubCategory", params: { category: root, subcategory: child } });
    },
    // SearchProductByTag(tag) {
    //   var query = "";
    //   if (this.userInfo) {
    //     query = `[ProductService.Tags][Name = '${tag}'] OR ProductService.Group = '${tag}'`;
    //   } else {
    //     query = "[Tags][Name = '" + tag + "']";
    //   }
    //   this.$router.push({ path: "/Products", query: { q: query } });
    // }
  },
  components:{
    CategoryTree,
    CategoryTiles
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-thumbnail:hover {
  cursor: pointer;
  background-color: #dee2e6;
}

.card-img-top{
  height: 15vw;
  object-fit: scale-down;
}

@media screen and (max-width: 768px) {
  .hide-by-width {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/category.vue